import React from "react";
import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography } from "@mui/material";

function CategoryDistributionChart(props) {
  const [outerSeries, setOuterSeries] = useState([52, 48]);
  const [innerSeries, setInnerSeries] = useState([59, 41]);

  useEffect(() => {
    if (props.category) {
      const gmsPercentage = props.category.gms.count
        ? ((props.category.gms.count / props.ab.total_12_month) * 100).toFixed(1) : 0
      let privatePercentage = 0;
      if(props.category.private.count > 0){
        privatePercentage = 100 - gmsPercentage
      }
      setOuterSeries([parseFloat(gmsPercentage), parseFloat(privatePercentage)]);
      const total = props.category.gms.patients + props.category.private.patients;
      const gmsInnerPercentage = props.category.gms.patients / total * 100;

      let privateInnerPercentage = 0;
      if(props.category.private.patients > 0){
        privateInnerPercentage = 100 - gmsInnerPercentage;
      }
      setInnerSeries([parseFloat(gmsInnerPercentage.toFixed(1)), parseFloat(privateInnerPercentage.toFixed(1))]);
    }
  },[props.category])

  const outerChartOptions = {
    chart: { type: "donut" },
    labels: ["Private patients", "Medical card patients"],
    colors: ["#4f9ea9", "#2C6785"], // Blue for Male, Orange for Female
    plotOptions: {
      pie: {
        donut: {
          size: "60%", // Proper ring size
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}%`,
      style: { fontSize: "16px", fontWeight: "bold" },
    },
    legend: { show: false },
    stroke: { width: 0 },
  };

  const innerChartOptions = {
    ...outerChartOptions,
    plotOptions: {
      pie: {
        donut: { size: "40%" }, // Inner ring smaller
      },
    },
  };

  return (
    <Box sx={{ textAlign: "left", width: 350, margin: "auto" }}>
      <Typography variant="h5" sx={{ color: "#22577A", fontWeight: "bold" }}>
        Category
      </Typography>
      <Typography variant="body1" sx={{ color: "#22577A", mb: 2 }}>
        <strong>Outer ring:</strong> antibiotics prescriptions.
        <br />
        <strong>Inner ring:</strong> patient population.
      </Typography>

      <Box sx={{ position: "relative" }}>
        {/* Outer Donut Chart */}
        <ReactApexChart
          type="donut"
          series={outerSeries} // Male, Female (Outer)
          options={outerChartOptions}
          height={300}
        />

        {/* Inner Donut Chart */}
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <ReactApexChart
            type="donut"
            series={innerSeries} // Male, Female (Inner)
            options={innerChartOptions}
            height={180}
          />
        </Box>
      </Box>
    </Box>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  category: state.antibiotics.category,
  ab: state.antibiotics.ab,
  user: state.user
});

const mapDispatch = ({
  antibiotics: { getGeneralAB }
}) => ({
  getGeneralAB: () => getGeneralAB()
});

export default connect(mapState, mapDispatch)(CategoryDistributionChart);
